import React, { useEffect, useState } from 'react';
import * as Styles from './styles';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import UnCheckIcon from '@/assets/Icons/empty-checkbox.svg';
import CheckIcon from '@/assets/Icons/checked-checkbox.svg';
import { useRouter } from 'next/router';
import { ROUTEMAP } from '../../constants';
import ModalWithCTAAndText from '@/components/common/modalWithCTAAndText';
import Router from '@/components/common/router';

interface LeavingSoonModalProps {
    isMobile: boolean;
    show: boolean;
    closeModal: () => void;
}

const leavingPageQuestions = [
    'I can’t find what I’m looking for',
    'I’m busy right now',
    'I’m just checking things out',
    'I need more help',
];

export default function LeavingSoonModal(props: LeavingSoonModalProps) {
    const { isMobile, show, closeModal } = props;
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [showHelpModal, setShowHelpModal] = useState<boolean>(false);
    const router = useRouter();

    const handleClick = () => {
        closeModal();
    };
    // useEffect(() => {
    //     // Log the selected items whenever they change
    //     console.log('Selected items:', selectedItems);
    // }, [selectedItems]);
    const handleCheckboxChange = (item: string) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(item)
                ? prevSelected.filter((selectedItem) => selectedItem !== item)
                : [...prevSelected, item]
        );
    };

    const handleSubmit = () => {
        //To do- API integration to capture the reason
        if (selectedItems.includes('I need more help')) {
            closeModal();
            setShowHelpModal(true);
        } else {
            Router.push(ROUTEMAP.GARAGE_PERIODIC_SERVICE);
        }
    };

    const handleHelpClick = () => {
        Router.push(ROUTEMAP.GARAGE_HELP_PAGE);
    };

    return (
        <>
            <Styles.CustomModal
                show={show}
                isMobile={isMobile || true}
                onClose={closeModal}
                hideClose
            >
                <Styles.Wrapper>
                    <Styles.Inner>
                        <Styles.PhotoBar>
                            <Styles.CatImage />
                            <Styles.Cross onClick={handleClick} />
                        </Styles.PhotoBar>

                        <Styles.BodyAfterPhoto>
                            <Styles.TextItems>
                                <span>Leaving already? We’ll miss you!</span>
                                <p>
                                    We’d like to know why you left, so we can
                                    improve your next visit
                                </p>
                            </Styles.TextItems>
                            <Styles.ListItems>
                                {leavingPageQuestions.map((val, index) => (
                                    <Styles.ListItem
                                        key={index}
                                        onClick={() =>
                                            handleCheckboxChange(val)
                                        }
                                    >
                                        {selectedItems.includes(val) ? (
                                            <CheckIcon />
                                        ) : (
                                            <UnCheckIcon />
                                        )}
                                        {val}
                                    </Styles.ListItem>
                                ))}
                            </Styles.ListItems>
                        </Styles.BodyAfterPhoto>
                    </Styles.Inner>
                    <Styles.CTAWrapper>
                        <PrimaryButton
                            onClick={handleSubmit}
                            disabled={selectedItems.length === 0}
                        >
                            <span>Submit</span>
                        </PrimaryButton>
                    </Styles.CTAWrapper>
                </Styles.Wrapper>
            </Styles.CustomModal>

            <ModalWithCTAAndText
                modalTYpe="NEED_HELP"
                show={showHelpModal}
                primaryCTAHandler={handleHelpClick}
                linkHandler={undefined}
                onClose={() => {
                    setShowHelpModal(false);
                }}
            />
        </>
    );
}
